import { Format } from "@/data/util/Format";

import { Ripple } from "@/shared/ui/Ripple";

import { MomentumScroller } from "@/app/ui/MomentumScroller";

export class CategorySlider {
    public onSelected?: { (category: string) };

    private $element: JQuery;
    private $slidable: JQuery;

    private scroller: MomentumScroller;
    private currentActiveId?: string;

    constructor() {
        this.$element = $('<div class="categoryslider" />');
        this.$slidable = $('<div class="slidable dragable" />').appendTo(this.$element);

        this.scroller = new MomentumScroller(this.$slidable, {
            axis: "x",
            restrictTo: this.$element,
        });
    }

    public setCategories(categories: Array<{ id: string; name: string }>): CategorySlider {
        let newWidth = 0;

        this.$slidable.empty();

        for (const i in categories) {
            const cat = categories[i];

            const el = $(
                '<div class="category initial" data-id="' + cat.id + '">' + Format.htmlEscape(cat.name) + "</div>"
            ).appendTo(this.$slidable);
            Ripple.bind(
                el.click((e) => {
                    if (this.scroller.isDragging) {
                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                    }

                    const clickedCategory = $(e.currentTarget);
                    this.moveSliderToElement(clickedCategory);
                    this.onCategoryClicked(clickedCategory);
                })
            );

            newWidth += el.outerWidth(true);
        }

        const parentWidth = this.$element.width();
        this.$slidable.width(newWidth < parentWidth ? parentWidth : newWidth);
        this.scroller.updateBounds();

        // todo: ugly solution to prevent flickering effect after load
        setTimeout(() => {
            this.$slidable.find("> .category.initial").removeClass("initial");
        }, 300);

        return this;
    }

    public moveToFirst(): CategorySlider {
        this.$slidable.find("> .category.active").removeClass("active");
        const newActive = this.$slidable.children(".category").first().addClass("initial").addClass("active");
        if (newActive.length > 0) {
            this.currentActiveId = newActive.attr("data-id");
            this.moveSliderToElement(newActive);
        } else this.currentActiveId = undefined;

        // todo: ugly solution to prevent flickering effect after load
        setTimeout(() => {
            this.$slidable.find("> .category.initial").removeClass("initial");
        }, 300);

        return this;
    }

    public moveScrollTo(id: string): CategorySlider | void {
        if (this.currentActiveId === id) return;

        const newActiveCat = this.$slidable.find('> .category[data-id="' + id + '"]');
        if (newActiveCat.length === 0) return;

        this.$slidable.find("> .category.active").removeClass("active");
        newActiveCat.addClass("active");

        this.currentActiveId = id;
        this.moveSliderToElement(newActiveCat);

        return this;
    }

    private onCategoryClicked(el: JQuery) {
        const currentActive = this.$slidable.find("> .category.active");
        currentActive.removeClass("active");
        el.addClass("active");

        this.currentActiveId = el.attr("data-id");
        if (this.onSelected !== undefined) this.onSelected(el.attr("data-id"));
    }

    public appendTo($element: JQuery): CategorySlider {
        this.$element.appendTo($element);
        return this;
    }

    private moveSliderToElement(atElement: JQuery) {
        let releasePos =
            atElement.position().left * -1 + parseInt(this.$slidable.css("padding-left").replace("px", ""));
        const maxOffset = this.$element.width() - this.$slidable.outerWidth(true);

        if (releasePos > 0) releasePos = 0;
        else if (maxOffset > releasePos) releasePos = maxOffset;

        this.scroller.scrollTo(releasePos, 0);
    }
}
